import { render, staticRenderFns } from "./DetailsPDFViewer.vue?vue&type=template&id=20ce290c&scoped=true"
import script from "./DetailsPDFViewer.vue?vue&type=script&lang=ts"
export * from "./DetailsPDFViewer.vue?vue&type=script&lang=ts"
import style0 from "./DetailsPDFViewer.vue?vue&type=style&index=0&id=20ce290c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce290c",
  null
  
)

export default component.exports